module.exports = __webpack_public_path__ + "fonts/BridgestoneType-Bold.26e7b372.ttf";